export const titleFont = "22px";
export const nameFont = "18px";
export const descFont = "16px";

export const avatar = "";
